import { useNavigate } from "react-router-dom";
import CancelButton from "../components/cancelButton/CancelButton";

const BackToOrderListButton = () => {
  const navigate = useNavigate();
  const navigateToOrderList = () => navigate("/orders");
  return <CancelButton onClick={navigateToOrderList}>Wróć do listy</CancelButton>;
};

export default BackToOrderListButton;
